// extracted by mini-css-extract-plugin
module.exports = {"Symbol":"PriceInput_Symbol__Cqmrw"};